<dx-data-grid
  #metricsTable
  *ngIf="inputDisplayMode === 'table'"
  [columnAutoWidth]="true"
  [dataSource]="metricList"
  [disabled]="(!selectedDeviceId && selectedDeviceId !== 0) || disabled || loadingData"
  [height]="'100%'"
  [keyExpr]="'id'"
  [wordWrapEnabled]="true"
  [showBorders]="true"
  [showRowLines]="false">
  <dxo-toolbar>
    <dxi-item cssClass="fullWidthSearchBar" location="before" name="searchPanel">
    </dxi-item>
  </dxo-toolbar>
  <dxo-search-panel
    [highlightSearchText]="true"
    [visible]="true">
  </dxo-search-panel>
  <dxo-scrolling
    mode="standard">
  </dxo-scrolling>
  <dxo-paging
    [pageSize]="10"
    [enabled]="appService.isSmallScreen()">
  </dxo-paging>
  <dxi-column [visible]="false" sortOrder="asc" dataField="id"></dxi-column>
  <dxi-column [dataField]="'name'" caption="{{'CHART_CREATION.METRIC_NAME' | translate}}"></dxi-column>
  <dxi-column [dataField]="'dataUnit'" caption="{{'CHART_CREATION.DATA_UNIT_SYMBOL' | translate}}"></dxi-column>
  <dxi-column [dataField]="'isWritableOnEdge'" [showEditorAlways]="false" [trueText]="translate.instant('COMMON.YES')" [falseText]="translate.instant('COMMON.NO')"
              caption="{{'CHART_CREATION.WRITEABLE_ON_EDGE' | translate}}"></dxi-column>
  <dxi-column [calculateDisplayValue]="parseLastValue" [dataField]="'lastValue'"
              [showEditorAlways]="false"
              caption="{{'CHART_CREATION.LAST_METRIC_VALUE' | translate}}"></dxi-column>
  <dxi-column type="buttons">
    <dxi-button template="buttonTemplate"></dxi-button>
  </dxi-column>
  <div *dxTemplate="let data of 'buttonTemplate'">
    <dx-button
      (onClick)="updateSelectedKeys(data);"
      [type]="'default'"
      icon="add"
      stylingMode="text">
    </dx-button>
  </div>
</dx-data-grid>

<dx-data-grid
  (onSelectionChanged)="listSelectionChanged.emit($event)"
  *ngIf="inputDisplayMode === 'list'"
  [columnAutoWidth]="true"
  [dataSource]="metricList"
  [disabled]="(!selectedDeviceId && selectedDeviceId !== 0) || disabled || loadingData"
  [height]="'100%'"
  [keyExpr]="'id'"
  [selectedRowKeys]="selectedMetricIds"
  [wordWrapEnabled]="true"
  [showBorders]="true"
  [showRowLines]="false">
  <dxo-selection
    [selectAllMode]="'allPages'"
    [showCheckBoxesMode]="'always'"
    mode="multiple">
  </dxo-selection>
  <dxo-toolbar>
    <dxi-item cssClass="fullWidthSearchBar" location="before" name="searchPanel">
    </dxi-item>
  </dxo-toolbar>
  <dxo-search-panel
    [highlightSearchText]="true"
    [visible]="true">
  </dxo-search-panel>
  <dxo-scrolling
    mode="standard">
  </dxo-scrolling>
  <dxi-column [visible]="false" sortOrder="asc" dataField="id"></dxi-column>
  <dxi-column [dataField]="'name'" caption="{{'CHART_CREATION.METRIC_NAME' | translate}}"></dxi-column>
  <dxi-column [dataField]="'dataUnit'" caption="{{'CHART_CREATION.DATA_UNIT_SYMBOL' | translate}}"></dxi-column>
  <dxi-column [calculateDisplayValue]="parseLastValue" [dataField]="'lastValue'"
              [showEditorAlways]="false"
              caption="{{'CHART_CREATION.LAST_METRIC_VALUE' | translate}}"></dxi-column>
  <div *dxTemplate="let data of 'buttonTemplate'">
    <dx-button
      (onClick)="updateSelectedKeys(data);"
      [type]="'default'"
      icon="add"
      stylingMode="text">
    </dx-button>
  </div>
</dx-data-grid>


<dx-drop-down-box
  #boxComponent
  *ngIf="inputDisplayMode === 'dropdown'"
  [dataSource]="metricList"
  [disabled]="(!selectedDeviceId && selectedDeviceId !== 0) || disabled || loadingData"
  [dropDownOptions]="{
            wrapperAttr:{ class: 'metricDropdown'}
          }"
  [value]="selectedMetricIds"
  displayExpr="name"
  placeholder="{{ 'CHART_CREATION.SELECT_METRIC' | translate }}"
  valueExpr="id">
  <dx-data-grid
    (onSelectionChanged)="boxComponent.instance.close(); checkForChangesAndEmit($event.selectedRowKeys)"
    [columnAutoWidth]="true"
    [dataSource]="metricList"
    [disabled]="(!selectedDeviceId && selectedDeviceId !== 0) || disabled"
    [height]="'100%'"
    [keyExpr]="'id'"
    [renderAsync]="true"
    [selectedRowKeys]="selectedMetricIds"
    [wordWrapEnabled]="true"
    [showBorders]="false"
    [showRowLines]="false">
    <dxo-selection
      mode="single">
    </dxo-selection>
    <dxo-toolbar>
      <dxi-item cssClass="fullWidthSearchBar" location="before" name="searchPanel">
      </dxi-item>
    </dxo-toolbar>
    <dxo-search-panel
      [visible]="true">
    </dxo-search-panel>
    <dxo-scrolling
      mode="standard">
    </dxo-scrolling>
    <dxi-column [visible]="false" sortOrder="asc" dataField="id"></dxi-column>
    <dxi-column [dataField]="'name'" caption="{{'CHART_CREATION.METRIC_NAME' | translate}}"></dxi-column>
    <dxi-column [dataField]="'dataUnit'" caption="{{'CHART_CREATION.DATA_UNIT_SYMBOL' | translate}}"></dxi-column>
    <dxi-column [calculateDisplayValue]="parseLastValue" [dataField]="'lastValue'"
                [showEditorAlways]="false"
                caption="{{'CHART_CREATION.LAST_METRIC_VALUE' | translate}}"></dxi-column>
  </dx-data-grid>
</dx-drop-down-box>
